module.exports = __webpack_public_path__ + "img/logo.66ccfbaf.png";